// Module
var code = "<div class=\"c-tieredPricingTooltip\">\n    <span ng-bind=\"context.minRenewalPeriod\"></span>\n    <span ng-bind=\"context.maxRenewalPeriod\"></span>\n</div>\n";
// Exports
module.exports = code;